import { type RefObject } from 'react'

import { useInfiniteScroll } from '@hooks/useInfiniteScroll'

interface InfiniteScrollSentinelProps {
  rootRef: RefObject<HTMLElement | null>
  hasNextPage?: boolean
  onLoadMore: () => void
  itemCount: number
}

export const InfiniteScrollSentinel = ({
  rootRef,
  hasNextPage,
  onLoadMore,
  itemCount,
}: InfiniteScrollSentinelProps) => {
  const sentinelRef = useInfiniteScroll({ rootRef, hasNextPage, onLoadMore, itemCount })

  if (!hasNextPage) return null

  return <div ref={sentinelRef} aria-hidden className='sticky left-0 h-px w-px' />
}
